import axios from "axios";
import logout from "../utils/logout";
import * as authClient from "./authClient";
import * as authProvider from "./authProvider";
import * as authSeller from "./authSeller";
import * as authUser from "./authUser";

interface IToken {
  access_token: string;
  iat: number;
  exp: number;
}

const api = axios.create({
  baseURL:
    process.env.NODE_ENV !== "development"
      ? "https://portal-legado-api.alpardobrasil.com.br"
      : "http://localhost:3333",
});

if (authUser.getToken() !== null) {
  api.interceptors.request.use(async (config) => {
    const { access_token, exp } = authUser.getToken() as unknown as IToken;

    const now = new Date();
    const tokenExp = new Date(exp * 1000);

    if (now < tokenExp) {
      if (access_token) {
        config.headers["x-access-token"] = `Bearer ${access_token}`;
      } else {
        logout();
        window.location.reload();
      }
    } else {
      logout();
      window.location.reload();
    }
    return config;
  });
}

if (authClient.getToken() !== null) {
  api.interceptors.request.use(async (config) => {
    const { access_token, exp } = authClient.getToken() as unknown as IToken;

    const now = new Date();
    const tokenExp = new Date(exp * 1000);

    if (now < tokenExp) {
      if (access_token) {
        config.headers["x-access-token"] = `Bearer ${access_token}`;
      } else {
        logout();
        window.location.reload();
      }
    } else {
      logout();
      window.location.reload();
    }
    return config;
  });
}

if (authProvider.getToken() !== null) {
  api.interceptors.request.use(async (config) => {
    const { access_token, exp } = authProvider.getToken() as unknown as IToken;

    const now = new Date();
    const tokenExp = new Date(exp * 1000);

    if (now < tokenExp) {
      if (access_token) {
        config.headers["x-access-token"] = `Bearer ${access_token}`;
      } else {
        logout();
        window.location.reload();
      }
    } else {
      logout();
      window.location.reload();
    }
    return config;
  });
}

if (authSeller.getToken() !== null) {
  api.interceptors.request.use(async (config) => {
    const { access_token, exp } = authSeller.getToken() as unknown as IToken;

    const now = new Date();
    const tokenExp = new Date(exp * 1000);

    if (now < tokenExp) {
      if (access_token) {
        config.headers["x-access-token"] = `Bearer ${access_token}`;
      } else {
        logout();
        window.location.reload();
      }
    } else {
      logout();
      window.location.reload();
    }
    return config;
  });
}

export default api;
